import { render, staticRenderFns } from "./CadastroMotorista.vue?vue&type=template&id=71fd4ab4"
import script from "./CadastroMotorista.vue?vue&type=script&lang=js"
export * from "./CadastroMotorista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports